// extracted by mini-css-extract-plugin
module.exports = {"Card":"commit_Card__34sQq","buttonReturn":"commit_buttonReturn__3bUzI","col":"commit_col__3aw80","author":"commit_author__2GZWz","titleCommit":"commit_titleCommit__1RG1K"};